<template lang="html">
<div>
    <h2 class="page-title">Активные объявления</h2>

    <div class="card-list my-card-list">
        <div class="grid-sizer"></div>
        <div class="gutter-sizer" ></div>
        <div class="card-wrapper" v-for="(ad, key) in ads">
            <div v-if="ad.views == false">
                Вы уверены, что хотите удалить объявление?
                <button @click="destroy(ad)">да</button>
                <button @click="ad.views = true">нет</button>
            </div>
            <div v-if="ad.description == false">
                Вы уверены, что хотите деактивировать объявление?
                <button @click="toggleActive(ad)">да</button>
                <button @click="ad.description = true">нет</button>
            </div>
            <div class="card clearfix">
                <a class="card-img" :href="'/show/' + ad.id">
                    <img v-if="ad.images[0]" :src="'/uploads/card/' + ad.images[0].title" alt="">
                    <img v-else :src="'/uploads/placeholder.jpg'" alt="a">
                </a>
                <a class="card-edit" :href="'/edit/' + ad.id"><span class="orangebutton">Изменить</span></a>
                <a class="card-onoff" :class="[ ad.active ? 'card-off' : 'card-on' ]" href="" @click.prevent="modalToggle(ad)"><span class="orangebutton">{{ ad.active ? 'Отключить' : 'Включить' }}</span></a>
                <a class="card-del" href="" @click.prevent="modalDel(ad)"><span class="orangebutton">Удалить</span></a>
                <a class="card-title blacklink" :title="ad.title" :href="'/show/' + ad.id">{{ ad.title }}</a>
                <div class="card-separator">
                    <span>хочу взамен:</span>
                </div>
                <div class="card-tags tags">
                    <a class="tag" v-for="tag in ad.tags" :href="'/tag/' + tag.name">{{ tag.name }}</a>
                </div>
            </div>
        </div>
    </div>
    <div class="load-more" v-if="!finish">
        <a href="" @click.prevent="loadmore()">Загрузить еще</a>
    </div>
</div>
</template>

<script>
import Masonry from 'masonry-layout';

    export default {

        data() {
            return {
                ads: [],
                finish: true,
                offset: 0,
                show: false
            }
        },

        created() {
            axios.post('/user?status=active').then(response => {
                this.ads = response.data[0];
                this.offset = response.data[1];
                this.finish = false  || this.ads.length == response.data[2];
            });
        },

        mounted: function() {
            $('.card-list').show()
        },

        updated: function() {
            var msnry = new Masonry('.card-list', {
                itemSelector: '.card-wrapper',
                columnWidth: '.grid-sizer',
                gutter: '.gutter-sizer',
                percentPosition: true,
                isResizable: false
            });
        },

        methods: {
            loadmore(data)  {
                axios.post('/user?status=active&offset=' + this.offset, data).then(response => {
                    this.ads = this.ads.concat(response.data[0]);
                    this.finish = !response.data[0].length || this.ads.length == response.data[2];
                    this.offset = this.ads.length;
                });
            },

            toggleActive(ad) {
                axios.post('/toggleactive/' + ad.id);

                var index = this.ads.indexOf(ad)
                this.ads.splice(index, 1);
            },

            modalDel(data) {
                var _this = this
                this.ads.forEach(function (ad) {
                    if (data.id == ad.id) {
                        ad.views = false
                    }
                })
            },

            modalToggle(data) {
                var _this = this
                this.ads.forEach(function (ad) {
                    if (data.id == ad.id) {
                        ad.description = false
                    }
                })
            },

            destroy(ad) {
                axios.post('/destroy/' + ad.id);

                var index = this.ads.indexOf(ad)
                this.ads.splice(index, 1);
            },
        }
    }
</script>